// extracted by mini-css-extract-plugin
export default {"randomTotals":"RandomCheckmark_randomTotals__Mkwp5"};